module.exports = __webpack_public_path__ + "img/AdobeStock_288622149.0b0e9ab1.png";